const getContentWrapperStyles = () => ({
    maxWidth: 'var(--site-corridor-max-width)',
    paddingLeft: 'var(--margin-content)',
    paddingRight: 'var(--margin-content)',
    marginLeft: 'auto',
    marginRight: 'auto',
});

export default getContentWrapperStyles;
